import React, { useState, useEffect, useContext } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import TabBasicInfo from "./PatientInfoTabs/TabBasicInfo";
import TabClinicalInfo from "./PatientInfoTabs/TabClinicalInfo";
import PatientActions from "./PatientActions";
import { PatientContext } from "../../../../context/PatientContext/PatientContext";

const PatientInfoTabs = ({ selectedPatientId, onAssignTask, onClick }) => {
  const [tab, setTab] = useState(0);
  const [patient, setPatient] = useState(null);
  const { fetchPatientDetails, loading } = useContext(PatientContext);

  useEffect(() => {
    const load = async () => {
      setPatient(null);
      const result = await fetchPatientDetails(selectedPatientId);
      if (Array.isArray(result)) setPatient(result[0]);
    };

    if (selectedPatientId) {
      load();
    }
  }, [selectedPatientId]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  if (loading || !patient) {
    return <Typography>Loading patient data...</Typography>;
  }

  return (
    <Box sx={{ width: "100%" }}>
      {/* Navegación por tabs */}
      <Tabs
        value={tab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 2 }}
      >
        <Tab label="🧾 Basic Info" />
        <Tab label="🩺 Clinical Info" />
        {/* Puedes agregar más tabs aquí */}
      </Tabs>

      {/* Contenido del tab */}
      {tab === 0 && (
        <>
          <TabBasicInfo patient={patient} />
          <PatientActions cipId={patient} onAssignTask={onAssignTask} onClick={onClick} />
        </>
      )}
      {tab === 1 && <TabClinicalInfo patient={patient} />}
    </Box>
  );
};

export default PatientInfoTabs;
